<template>
  <div class="card">
    <div :class="`${$style.head} card-header`">
      <div :class="$style.headItem" class="mb-3 pr-3">
        <div :class="$style.headIcon" class="bg-light text-dark mr-3">
          <i class="fe fe-menu font-size-18" />
        </div>
        <div>
          <div class="text-uppercase text-muted text-nowrap">Jumlah Data</div>
          <div class="font-weight-bold text-dark">
            {{ filteredData.length }}
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="d-inline-block mr-2 mt-3 mt-sm-0 mb-3 mb-sm-3">
        <label><strong> Cari berdasarkan kode pasien </strong></label> <br />
        <a-input-search
          style="width: 200px"
          placeholder="Search by code..."
          @search="onSearch"
        />
      </div>

      <a-divider />
      <div class="mb-4" style="z-index: 1">
        <a-modal :footer="null" v-model="visible">
          <span slot="title"
            ><strong> Daftar obat yang sudah diminum </strong>
          </span>
          <a-list
            :class="$style.scroll"
            item-layout="horizontal"
            :data-source="pills"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <a v-if="item.hour != null" slot="title"
                  ><strong
                    >Obat sudah diminum pada pukul {{ item.hour }}:{{
                      item.minute
                    }}.
                    <span class="float-right mr-3">{{
                      moment(item.createdAt).format('YYYY-MM-DD')
                    }}</span></strong
                  ></a
                >
                <a v-else slot="title"
                  >Obat belum diminum.
                  <strong>
                    <span class="float-right mr-3">{{
                      moment(item.createdAt).format('YYYY-MM-DD')
                    }}</span></strong
                  ></a
                >
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-modal>
        <a-modal :footer="null" v-model="modalRedemption" width="100vw">
          <a-table
            :columns="columnsRedemption"
            :dataSource="selectedRedemptionRecord"
            style="margin-top: 15px"
            :pagination="false"
            rowKey="id"
          >
            <template slot="mad" slot-scope="mad, record">
              <div class="justify-content-between" v-if="record.takenpills">
                <a
                  @click="showModal(record)"
                  class="kit__utils__link font-size-16 mr-3"
                  >{{ parseFloat(mad).toFixed(2) }}%</a
                >
                <strong style="font-size: 20px" class="float-right"
                  ><sup>{{ record.takenpills }}</sup
                  >&frasl;<sub>{{ record.prescription }}</sub></strong
                >
              </div>
              <a-tag color="volcano" v-else
                ><a-icon type="minus"></a-icon
              ></a-tag>
            </template>
          </a-table>
        </a-modal>
        <a-table
          style="z-index: 1"
          :columns="columns"
          :dataSource="filteredData"
          :pagination="true"
          :class="$style.table"
          rowKey="id"
          :loading="isLoading"
        >
          <template slot="code" slot-scope="code, record">
            <div>
              <div v-if="isAdmin">
                <div v-if="record.program && record.program.checkPoint >= 5">
                  <router-link
                    :to="{ path: '/pasien/details/' + code }"
                    class="kit__utils__link font-size-16"
                    >{{ code ? code : '-' }}</router-link
                  >
                </div>
                <div v-else>
                  <router-link
                    :to="{ path: '/pasien/program/tambah/' + code }"
                    class="kit__utils__link font-size-16"
                    >{{ code ? code : '-' }}</router-link
                  >
                </div>
              </div>
              <div v-if="!isAdmin">
                <div v-if="record.program && record.program.checkPoint >= 5">
                  <router-link
                    :to="{ path: '/pasien/details/' + code }"
                    class="kit__utils__link font-size-16"
                    >{{ code ? code : '-' }}</router-link
                  >
                </div>
                <div v-else>
                  {{ code ? code : '-' }}
                </div>
              </div>
              <div class="text-gray-4">
                {{ record.city ? record.city : '-' }}
              </div>
            </div>
          </template>
          <template slot="enrollDate" slot-scope="enrollDate">
            <div>
              <div>
                {{
                  enrollDate
                    ? moment(enrollDate).format('DD MMM YYYY HH:mm:ss')
                    : '-'
                }}
              </div>
            </div>
          </template>
          <template slot="verifDate" slot-scope="verifDate">
            <div>
              <div>
                {{
                  verifDate
                    ? moment(verifDate).format('DD MMM YYYY HH:mm:ss')
                    : '-'
                }}
              </div>
            </div>
          </template>
          <template slot="extendDate" slot-scope="extendDate">
            <div>
              <div>
                {{
                  extendDate
                    ? moment(extendDate).format('DD MMM YYYY HH:mm:ss')
                    : '-'
                }}
              </div>
            </div>
          </template>
          <template slot="testLabs" slot-scope="testLabs">
            <!-- <p>{{ JSON.stringify(testLabs) }}</p> -->
            <template v-if="testLabs.length">
              <div v-for="(item, i) in testLabs" :key="i">
                <a-tag class="my-1">{{ item }}</a-tag>
              </div>
            </template>
            <div v-else>-</div>
          </template>
          <template slot="terminatedDate" slot-scope="terminatedDate">
            <div>
              <div>
                {{
                  terminatedDate
                    ? moment(terminatedDate).format('DD MMM YYYY')
                    : '-'
                }}
              </div>
            </div>
          </template>
          <template slot="city" slot-scope="city">
            <div>
              <div>{{ city ? city : '-' }}</div>
            </div>
          </template>
          <template slot="doctor" slot-scope="doctor">
            <div>
              <div>{{ doctor ? doctor.fullname : '-' }}</div>
              <div class="text-gray-4">
                {{ doctor ? doctor.hospital : '-' }}
              </div>
            </div>
          </template>
          <template slot="pharmacy" slot-scope="pharmacy">
            <div>
              <div>{{ pharmacy ? pharmacy.name : '-' }}</div>
            </div>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-popover>
              <span
                slot="content"
                class="kit__utils__link font-size-16 text-success"
                >Kirim Email</span
              >
              <button
                @click="email(record)"
                type="button"
                class="btn btn-outline-success"
              >
                <i class="far fa-envelope"></i>
              </button>
            </a-popover>
          </template>
          <template slot="isTerminated" slot-scope="isTerminated, record">
            <a-tag
              :color="
                getStatus(isTerminated, record) === 'Berhenti'
                  ? 'volcano'
                  : getStatus(isTerminated, record) === 'Tidak Aktif'
                  ? 'orange'
                  : getStatus(isTerminated, record) === 'Pasien Baru'
                  ? 'green'
                  : getStatus(isTerminated, record) === 'Belum Scan QR'
                  ? 'orange'
                  : getStatus(isTerminated, record) === 'Belum Terdaftar'
                  ? 'orange'
                  : getStatus(isTerminated, record) === 'Perpanjang'
                  ? 'blue'
                  : 'lightgrey'
              "
            >
              {{ getStatus(isTerminated, record) }}
            </a-tag>
          </template>
          <template slot="mad" slot-scope="mad, record">
            <div class="justify-content-between" v-if="record.takenpills">
              <a
                @click="showModal(record)"
                class="kit__utils__link font-size-16 mr-3"
                >{{ parseFloat(mad).toFixed(2) }}%</a
              >
              <strong style="font-size: 20px" class="float-right"
                ><sup>{{ record.takenpills }}</sup
                >&frasl;<sub>{{ record.prescription }}</sub></strong
              >
            </div>
          </template>
          <template slot="terminatedMessage" slot-scope="terminatedMessage">
            <a-tag
              v-if="terminatedMessage === 'Meninggal Dunia'"
              :color="'volcano'"
            >
              {{ terminatedMessage }}
            </a-tag>
            <span v-else>
              {{ terminatedMessage ? terminatedMessage : '-' }}
            </span>
          </template>
          <!-- <template
          v-for="(monthData, i) in months"
          :slot="monthData"
          slot-scope="text, record"
        >
          <div :key="i">
            {{ text }} <br />
            <div class="text-gray-4">
              {{ record[`${monthData}PriceName`] }}
            </div>
          </div>
        </template> -->
          <template slot="redemp" slot-scope="redemp, record">
            <!-- <p>{{ JSON.stringify(record, null, 2) }}</p> -->
            <!-- <a-button @click="() => handleShowModalRedemption(record)"
            >Check</a-button
          > -->
            <a-select
              style="width: 180px; z-index: 99"
              @change="(val) => onYearRedemptionChanged(val, record)"
              @dropdownVisibleChange="
                (open) => {
                  getYearRedemption(record, open)
                }
              "
            >
              <a-select-option
                v-for="(year, i) in selectedRedemptionYearRow"
                :label="year"
                :key="i"
                :value="year"
              >
                {{ year }}
              </a-select-option>
            </a-select>

            <!-- <p v-else>{{ JSON.stringify(record.takenpills) }}</p> -->
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import HtmlTableToJson from 'html-table-to-json'
import XLSX from 'xlsx'
// import data from './data.json'
// import { getAllPatientData, bulkGetByCode } from '@/services/axios/api/pasien'
import {
  // getAllPatientData,
  bulkCreate,
  sendEmail,
  // getRedemptionByCode,
} from '@/services/axios/api/pasien'
import {
  listAllTakenPills,
  listAllPillsStatus,
} from '@/services/axios/api/pillsTaken'
import moment from 'moment'
import router from '@/router'
import fuzzysort from 'fuzzysort'
import { mapGetters } from 'vuex'
import { getLatestPatientData } from '../../../services/axios/api/pasien'
const columns = [
  {
    title: 'Data Utama',
    className: 'border bg-transparent text-gray-6',
    children: [
      {
        title: 'Pasien',
        dataIndex: 'code',
        className: 'bg-transparent border-left text-gray-6 width-50',
        scopedSlots: { customRender: 'code' },
        fixed: 'left',
        sorter: (a, b) => {
          return a.code.localeCompare(b.code)
        },
        filters: [],
        // onFilter: (value, record) => {
        //   return record.city === value
        // },
      },
      {
        title: 'Redemption Date',
        dataIndex: 'redemp',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'redemp' },
        fixed: 'left',
        filters: [],
        // sorter: (a, b) => a.mad - b.mad,
        // onFilter: (value, record) => {
        //   return record.city === value
        // },
      },
      {
        title: 'Tanggal Pengajuan',
        dataIndex: 'program.enrollDate',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'enrollDate' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else if (!a.program.enrollDate) {
            return -1
          } else if (!b.program.enrollDate) {
            return 1
          } else {
            return a.program.enrollDate.localeCompare(b.program.enrollDate)
          }
        },
      },
      {
        title: 'Tanggal Perpanjang',
        dataIndex: 'program.createdAt',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'extendDate' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else if (!a.program.createdAt) {
            return -1
          } else if (!b.program.createdAt) {
            return 1
          } else {
            return a.program.createdAt.localeCompare(b.program.createdAt)
          }
        },
      },
      {
        title: 'Tanggal Verifikasi',
        dataIndex: 'program.drugsTakenDate',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'verifDate' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else if (!a.program.drugsTakenDate) {
            return -1
          } else if (!b.program.drugsTakenDate) {
            return 1
          } else {
            return a.program.drugsTakenDate.localeCompare(
              b.program.drugsTakenDate,
            )
          }
        },
      },
      {
        title: 'Tanggal Berhenti',
        dataIndex: 'program.terminatedDate',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'terminatedDate' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else if (!a.program.terminatedDate) {
            return -1
          } else if (!b.program.terminatedDate) {
            return 1
          } else {
            return a.program.terminatedDate.localeCompare(
              b.program.terminatedDate,
            )
          }
        },
      },
      {
        title: 'Dokter',
        dataIndex: 'doctor',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'doctor' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else {
            return a.doctor.fullname.localeCompare(b.doctor.fullname)
          }
        },
        filters: [],
        // onFilter: (value, record) => {
        //   return record.doctor ? record.doctor.fullname === value : -1
        // },
      },
      {
        title: 'Farmasi',
        dataIndex: 'program.pharmacy',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'pharmacy' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else if (!a.program.pharmacy) {
            return -1
          } else if (!b.program.pharmacy) {
            return 1
          } else {
            return a.program.pharmacy.name.localeCompare(
              b.program.pharmacy.name,
            )
          }
        },
        filters: [],
        // onFilter: (value, record) => {
        //   return record.pharmacy ? record.pharmacy.name === value : -1
        // },
      },
      {
        title: 'Status',
        dataIndex: 'program.isTerminated',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'isTerminated' },
      },
      {
        title: 'Program',
        dataIndex: 'programType',
        className: 'bg-transparent',
        filters: [
          {
            text: 'TAGRISSO',
            value: 'TAGRISSO',
          },
          {
            text: 'FASLODEX',
            value: 'FASLODEX',
          },
          {
            text: 'LYNPARZA',
            value: 'LYNPARZA',
          },
          {
            text: 'IMFINZI',
            value: 'IMFINZI',
          },
          {
            text: 'CALQUENCE',
            value: 'CALQUENCE',
          },
        ],
        onFilter: (value, record) => {
          return record.programType === value
        },
        scopedSlots: { customRender: 'programType' },
      },
      {
        title: 'Test Lab',
        dataIndex: 'testLabs',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'testLabs' },
      },
      {
        title: 'DoT',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'dot' },
        sorter: (a, b) => a.dot - b.dot,
        dataIndex: 'dot',
      },
      {
        title: 'Medical Adherence',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'mad' },
        sorter: (a, b) => a.mad - b.mad,
        dataIndex: 'mad',
      },
      {
        title: 'Alasan Berhenti',
        dataIndex: 'terminatedMessage',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'terminatedMessage' },
        filters: [],
        // onFilter: (value, record) => {
        //   return record.terminatedMessage ? record.terminatedMessage === value : 0
        // },
      },
      {
        title: 'Action',
        dataIndex: 'action',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'action' },
      },
    ],
  },
  // {
  //   title: 'Redemption Date',
  //   className: 'border bg-transparent text-gray-6',
  //   scopedSlots: { customRender: 'redemption' },
  //   children: [
  // {
  //   title: 'DoT',
  //   className: 'border bg-transparent text-gray-6',
  //   scopedSlots: { customRender: 'dot' },
  //   sorter: (a, b) => a.dot - b.dot,
  //   dataIndex: 'dot',
  // },
  // {
  //   title: 'Medical Adherence',
  //   className: 'border bg-transparent text-gray-6',
  //   scopedSlots: { customRender: 'mad' },
  //   sorter: (a, b) => a.mad - b.mad,
  //   dataIndex: 'mad',
  // },
  //     {
  //       title: 'Januari',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'januari' },
  //       sorter: (a, b) => a.januari.length - b.januari.length,
  //       dataIndex: 'januari',
  //     },
  //     {
  //       title: 'Februari',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'februari' },
  //       dataIndex: 'februari',
  //       sorter: (a, b) => a.februari.length - b.februari.length,
  //     },
  //     {
  //       title: 'Maret',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'maret' },
  //       dataIndex: 'maret',
  //       sorter: (a, b) => a.maret.length - b.maret.length,
  //     },
  //     {
  //       title: 'April',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'april' },
  //       dataIndex: 'april',
  //       sorter: (a, b) => a.april.length - b.april.length,
  //     },
  //     {
  //       title: 'Mei',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'mei' },
  //       dataIndex: 'mei',
  //       sorter: (a, b) => a.mei.length - b.mei.length,
  //     },
  //     {
  //       title: 'Juni',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'juni' },
  //       dataIndex: 'juni',
  //       sorter: (a, b) => a.juni.length - b.juni.length,
  //     },
  //     {
  //       title: 'Juli',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'juli' },
  //       dataIndex: 'juli',
  //       sorter: (a, b) => a.juli.length - b.juli.length,
  //     },
  //     {
  //       title: 'Agustus',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'agustus' },
  //       dataIndex: 'agustus',
  //       sorter: (a, b) => a.agustus.length - b.agustus.length,
  //     },
  //     {
  //       title: 'September',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'september' },
  //       dataIndex: 'september',
  //       sorter: (a, b) => a.september.length - b.september.length,
  //     },
  //     {
  //       title: 'Oktober',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'oktober' },
  //       dataIndex: 'oktober',
  //       sorter: (a, b) => a.oktober.length - b.oktober.length,
  //     },
  //     {
  //       title: 'November',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'november' },
  //       dataIndex: 'november',
  //       sorter: (a, b) => a.november.length - b.november.length,
  //     },
  //     {
  //       title: 'Desember',
  //       className: 'border bg-transparent text-gray-6',
  //       scopedSlots: { customRender: 'desember' },
  //       dataIndex: 'desember',
  //       sorter: (a, b) => a.desember.length - b.desember.length,
  //     },
  //   ],
  // },
]
const columnsRedemption = [
  {
    title: 'Redemption Date',
    className: 'border bg-transparent text-gray-6',
    scopedSlots: { customRender: 'redemption' },
    children: [
      // {
      //   title: 'DoT',
      //   className: 'border bg-transparent text-gray-6',
      //   scopedSlots: { customRender: 'dot' },
      //   sorter: (a, b) => a.dot - b.dot,
      //   dataIndex: 'dot',
      // },
      // {
      //   title: 'Medical Adherence',
      //   className: 'border bg-transparent text-gray-6',
      //   scopedSlots: { customRender: 'mad' },
      //   sorter: (a, b) => a.mad - b.mad,
      //   dataIndex: 'mad',
      // },
      {
        title: 'Januari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'januari' },
        sorter: (a, b) => a.januari.length - b.januari.length,
        dataIndex: 'januari',
      },
      {
        title: 'Februari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'februari' },
        dataIndex: 'februari',
        sorter: (a, b) => a.februari.length - b.februari.length,
      },
      {
        title: 'Maret',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'maret' },
        dataIndex: 'maret',
        sorter: (a, b) => a.maret.length - b.maret.length,
      },
      {
        title: 'April',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'april' },
        dataIndex: 'april',
        sorter: (a, b) => a.april.length - b.april.length,
      },
      {
        title: 'Mei',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'mei' },
        dataIndex: 'mei',
        sorter: (a, b) => a.mei.length - b.mei.length,
      },
      {
        title: 'Juni',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juni' },
        dataIndex: 'juni',
        sorter: (a, b) => a.juni.length - b.juni.length,
      },
      {
        title: 'Juli',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juli' },
        dataIndex: 'juli',
        sorter: (a, b) => a.juli.length - b.juli.length,
      },
      {
        title: 'Agustus',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'agustus' },
        dataIndex: 'agustus',
        sorter: (a, b) => a.agustus.length - b.agustus.length,
      },
      {
        title: 'September',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'september' },
        dataIndex: 'september',
        sorter: (a, b) => a.september.length - b.september.length,
      },
      {
        title: 'Oktober',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'oktober' },
        dataIndex: 'oktober',
        sorter: (a, b) => a.oktober.length - b.oktober.length,
      },
      {
        title: 'November',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'november' },
        dataIndex: 'november',
        sorter: (a, b) => a.november.length - b.november.length,
      },
      {
        title: 'Desember',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'desember' },
        dataIndex: 'desember',
        sorter: (a, b) => a.desember.length - b.desember.length,
      },
    ],
  },
]

export default {
  name: 'DashboardLatest',
  data: function () {
    return {
      columns,
      columnsRedemption,
      // data,?
      visible: false,
      months: [
        'januari',
        'februari',
        'maret',
        'april',
        'mei',
        'juni',
        'juli',
        'agustus',
        'september',
        'oktober',
        'november',
        'desember',
      ],
      year: '2020',
      yearRedemption: '',
      items: [],
      selectedDoctorFilter: [],
      selectedCityFilter: [],
      selectedPharmacyFilters: [],
      selectedStatusFilters: '',
      selectedDeathCauseFilters: [],
      cityFilters: [],
      doctorFilters: [],
      pharmacyFilters: [],
      statusFilters: [],
      deathCauseFilters: [],
      totalDoT: 0,
      meanDoT: 0,
      medianDoT: 0,
      isLoading: true,
      pills: [],
      isAdmin: false,
      dataLen: 0,
      filtered: [],
      count: 0,
      cancelToken: '',
      selectedRedemptionRecord: [],
      selectedRedemptionYearRow: [],
      programsRedemption: [],
      modalRedemption: false,
      testingData: [],
    }
  },
  computed: {
    filteredData: {
      get() {
        return this.filtered
      },
      set(newValue) {
        this.filtered = newValue
      },
    },
    ...mapGetters('user', ['user']),
  },
  created() {
    // this.testingEndpoint()
    this.cacheOrDatabase()
    this.getRole()
    // this.getAllPatient('tagrisso')
  },
  methods: {
    moment,
    async getYearRedemption(record, open) {
      // this.redemptionLoading = true
      if (open) {
        const programsRedemption = record.programs
        programsRedemption.forEach((el) => {
          const comparison = moment(el.red).year()
          if (!this.selectedRedemptionYearRow.includes(comparison)) {
            // cityFilters.push(user.city)
            this.selectedRedemptionYearRow.push(comparison)
          }
        })
        this.selectedRedemptionYearRow.sort()
        // this.redemptionLoading = false
        // console.log(programsRedemption, '<<<<')
      } else {
        this.selectedRedemptionYearRow = []
      }
    },
    showModal(record) {
      this.listPillsTaken(record)
      this.visible = true
    },
    handleShowModalRedemption(record) {
      this.selectedRedemptionRecord = [record]
      this.modalRedemption = true
      // console.log(record, '<<<<<<<<REDEMP')
    },
    async email(record) {
      // console.log(record, 'record')
      const res = await sendEmail(record.email)
      // console.log(res, 'result email')
      if (res.data) {
        this.$notification.success({
          message: 'Berhasil',
          description: res.data.data,
          duration: 5,
        })
      }
    },
    onTypeChange(val) {
      this.year = val
      this.getAllPatient()
    },
    onYearRedemptionChanged(val, record) {
      // this.yearRedemption = val
      const user = this.listRedemptionDatesModal(record, val)
      this.handleShowModalRedemption(user)
      // console.log(user)
      // console.log(
      //   this.programsRedemption.filter((el) => moment(el.red).year() === val),
      //   '<<<<<<,',
      // )
    },
    listRedemptionDatesModal(user, year) {
      user.januari = '-'
      user.februari = '-'
      user.maret = '-'
      user.april = '-'
      user.mei = '-'
      user.juni = '-'
      user.juli = '-'
      user.agustus = '-'
      user.september = '-'
      user.oktober = '-'
      user.november = '-'
      user.desember = '-'
      if (user.code === '2021JAM003') {
        console.log(this.year, 'this year')
        console.log(user.programs, 'programs')
      }
      for (const j in user.programs) {
        // const redemption = user.programs[j].enrollDate ? user.programs[j].enrollDate : user.programs[j].createdAt
        const redemption = user.programs[j].red
        const program = user.programs[j]
        if (
          moment(redemption).isBefore(`${year}-01-30`, 'day') &&
          moment(redemption).isAfter(`${year}-01-01`, 'day')
        ) {
          user.januariPriceName = program.price ? program.price.name : '-'
          user.januari = redemption
            ? moment(redemption).format('DD-MM-YYYY')
            : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-02-28`, 'day') &&
          moment(redemption).isAfter(`${year}-02-01`, 'day')
        ) {
          user.februari =
            redemption !== null ? moment(redemption).format('DD-MM-YYYY') : '-'
          user.februariPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-03-30`, 'day') &&
          moment(redemption).isAfter(`${year}-03-01`, 'day')
        ) {
          user.maret = moment(redemption).format('DD-MM-YYYY')
          user.maretPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-04-30`, 'day') &&
          moment(redemption).isAfter(`${year}-04-01`, 'day')
        ) {
          user.april = moment(redemption).format('DD-MM-YYYY')
          user.aprilPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-05-30`, 'day') &&
          moment(redemption).isAfter(`${year}-05-01`, 'day')
        ) {
          user.mei = moment(redemption).format('DD-MM-YYYY')
          user.meiPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-06-30`, 'day') &&
          moment(redemption).isAfter(`${year}-06-01`, 'day')
        ) {
          user.juni = moment(redemption).format('DD-MM-YYYY')
          user.juniPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-07-30`, 'day') &&
          moment(redemption).isAfter(`${year}-07-01`, 'day')
        ) {
          user.juli = moment(redemption).format('DD-MM-YYYY')
          user.juliPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-08-30`, 'day') &&
          moment(redemption).isAfter(`${year}-08-01`, 'day')
        ) {
          user.agustus = moment(redemption).format('DD-MM-YYYY')
          if (user.code === '2021JAM003') {
            console.log('masuk agustus')
            console.log(user.agustus)
          }
          user.agustusPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-09-30`, 'day') &&
          moment(redemption).isAfter(`${year}-09-01`, 'day')
        ) {
          user.september = moment(redemption).format('DD-MM-YYYY')
          user.septemberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-10-30`, 'day') &&
          moment(redemption).isAfter(`${year}-10-01`, 'day')
        ) {
          user.oktober = moment(redemption).format('DD-MM-YYYY')
          user.oktoberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-11-30`, 'day') &&
          moment(redemption).isAfter(`${year}-11-01`, 'day')
        ) {
          user.november = moment(redemption).format('DD-MM-YYYY')
          user.novemberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${year}-12-30`, 'day') &&
          moment(redemption).isAfter(`${year}-12-01`, 'day')
        ) {
          user.desember = moment(redemption).format('DD-MM-YYYY')
          user.desemberPriceName = program.price ? program.price.name : '-'
        }
      }
      return user
    },
    onSearch(searchText) {
      if (searchText !== '') {
        const results = fuzzysort.go(searchText, this.items, { key: 'code' })
        const filteredData = results.map((result) => {
          return result.obj
        })
        // console.log(results)
        this.onFilter(filteredData)
        // this.filteredData = filteredData
      } else {
        // this.filteredData = this.items
        this.onFilter(this.items)
      }
    },
    getRole() {
      const role = window.localStorage.getItem('role')
      console.log(role)
      if (role === 'admin') {
        this.isAdmin = true
      }
    },
    getStatus(isTerminated, record) {
      // console.log(record, 'record')
      // console.log('record program', record.program)
      return record.program
        ? record.program.checkPoint === 6
          ? isTerminated
            ? 'Berhenti'
            : 'Perpanjang'
          : record.program.isDrugsTaken === null
          ? 'Belum Scan QR'
          : record.program.reminderDate &&
            moment(record.program.reminderDate).isBefore(
              moment().subtract(2, 'months'),
            )
          ? 'Tidak Aktif'
          : record.program.prevProgram
          ? 'Perpanjang'
          : 'Pasien Baru'
        : 'Belum Terdaftar'
      // if (record.program) {
      //   // if (record.program && record.isApproved && isTerminated !== true && record.checkPoint !== 6 && record.isDrugsTaken === false) return 'Belum Scan QR'
      //   if (record.program && record.checkPoint !== 6 && record.prevProgram === null && record.isTerminated === null) return 'Pasien Baru'
      //   else if (record.prevProgram && isTerminated === false && record.isDrugsTaken === true) return 'Perpanjang'
      //   else if (record.isTerminated === true) return 'Berhenti'
      // } else {
      //   return 'Belum Terdaftar'
      // }
    },
    async convertExcel(e) {
      var reader = new FileReader()
      // console.log(e)
      reader.readAsArrayBuffer(e.file.originFileObj)
      reader.onload = async (e) => {
        var data = new Uint8Array(reader.result)
        var wb = XLSX.read(data, { type: 'array' })
        var htmlstr = XLSX.write(wb, {
          sheet: wb.SheetNames[0],
          type: 'binary',
          bookType: 'html',
        })
        const jsonTables = HtmlTableToJson.parse(htmlstr)
        const tableExcel = jsonTables.results[0]
        for (const i in tableExcel) {
          const cell = tableExcel[i]
          cell.store_name = `Apotek ${cell.CUSTOMER_NAME}`
          cell.store_name = cell.store_name.replaceAll('AP', '')
          cell.store_name = cell.store_name.replaceAll('.', '')
          cell.store_name = cell.store_name.replaceAll(',', ' ')
          cell.city = cell.BRANCH.replaceAll('PT. APL ', '')
          cell.city = cell.city.replaceAll(' 1', '').toLowerCase()
          cell.city = cell.city.charAt(0).toUpperCase() + cell.city.slice(1)
          const addressRaw = `${cell.ADDRESS}`.toUpperCase()
          const containsCity = addressRaw.includes(cell.city.toUpperCase())
          if (!containsCity) {
            cell.address = `${cell.ADDRESS} ${cell.city}`
          } else {
            cell.address = cell.ADDRESS
          }
          // if (unlisted.includes(cell.store_name)) {
          //   filteredTables.push(cell)
          // }
        }
        // eslint-disable-next-line
        // console.log(tableExcel)
      }
    },
    async migrateDoctor(e) {
      var reader = new FileReader()
      // console.log(e)
      reader.readAsArrayBuffer(e.file.originFileObj)
      reader.onload = async (e) => {
        var data = new Uint8Array(reader.result)
        var wb = XLSX.read(data, { type: 'array' })
        var htmlstr = XLSX.write(wb, {
          sheet: wb.SheetNames[1],
          type: 'binary',
          bookType: 'html',
        })
        const jsonTables = HtmlTableToJson.parse(htmlstr)
        // eslint-disable-next-line
        const tableExcel = jsonTables.results[0]
        // for (const i in tableExcel) {
        // }
        // console.log(tableExcel)
      }
    },
    async convertTable(e) {
      var reader = new FileReader()
      // console.log(e)
      reader.readAsArrayBuffer(e.file.originFileObj)
      reader.onload = async (e) => {
        var data = new Uint8Array(reader.result)
        var wb = XLSX.read(data, { type: 'array' })
        var htmlstr = XLSX.write(wb, {
          sheet: wb.SheetNames[0],
          type: 'binary',
          bookType: 'html',
        })
        const jsonTables = HtmlTableToJson.parse(htmlstr)
        const tableExcel = jsonTables.results[0]
        tableExcel.forEach((x) => {
          if (x.Pasien) {
            const patient = x.Pasien.replaceAll('-', '')
            x.Pasien = patient
          }
          if (x.Pasien === '2020SMG246')
            x['17'] === ''
              ? console.log(x['17'], 'smg246')
              : console.log('kok bisa')
          // x['Enroll Date'] = x['Tanggal Bergabung']
          if (x['Enroll Date'] && x['Enroll Date'] !== 'null') {
            const enrollDate = x['Enroll Date']
            let enrollDateResult = ''
            enrollDateResult = moment(enrollDate).format('DD/MM/YYYY')
            if (enrollDateResult === 'Invalid date') {
              enrollDateResult = moment(enrollDate, 'DD/MM/YYYY').format(
                'DD/MM/YYYY',
              )
            }
            //   // if (enrollDate.includes(',')) {
            //   //   const replaced = enrollDate.replace(',', '')
            //   //   x['Enroll Date'] = moment(replaced, 'DD/MM/YYYY').format('YYYY-MM-DD')
            //   // } else if (enrollDate.includes('.')) {
            //   //   const replaced = enrollDate.replace('.', '').trim()
            //   //   x['Enroll Date'] = moment(replaced, 'DD/MM/YYYY').format('YYYY-MM-DD')
            //   //   if (x.Pasien === '021-PWK-399') console.log(replaced, 'enrolldate')
            //   //   if (x.Pasien === '021-PWK-399') console.log(moment('23-03-2021', 'DD/MM/YYYY').format('YYYY-MM-DD'), 'enrolldate')
            //   // } else if (enrollDate.includes('/')) {
            //   //   x['Enroll Date'] = moment(enrollDate, 'DD/MM/YYYY[T]HH:mm:ss').format('YYYY-MM-DD')
            //   // } else {
            //   //   x['Enroll Date'] = moment(enrollDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
            //   // }
            x['Enroll Date'] = enrollDateResult
          }
          if (x['Januari 2021'] && x['Januari 2021'] !== '') {
            let redemption = x['Januari 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Januari 2021'] = redemption
            const words = redemption.split(' ')
            x[36] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price13 = price.join('')
                } else {
                  x.price13 = price[0]
                }
              }
            }
            // x.price13 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['Februari 2021'] && x['Februari 2021'] !== '') {
            let redemption = x['Februari 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Februari 2021'] = redemption
            const words = redemption.split(' ')
            x[37] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price14 = price.join('')
                } else {
                  x.price14 = price[0]
                }
              }
            }
            // x.price14 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['Maret 2021'] && x['Maret 2021'] !== '') {
            let redemption = x['Maret 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Maret 2021'] = redemption
            const words = redemption.split(' ')
            x[38] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price15 = price.join('')
                } else {
                  x.price15 = price[0]
                }
              }
            }
            // x.price15 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['April 2021'] && x['April 2021'] !== '') {
            let redemption = x['April 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['April 2021'] = redemption
            const words = redemption.split(' ')
            x[39] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price16 = price.join('')
                } else {
                  x.price16 = price[0]
                }
              }
            }
            // x.price16 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['Mei 2021'] && x['Mei 2021']) {
            let redemption = x['Mei 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Mei 2021'] = redemption
            const words = redemption.split(' ')
            x[40] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price17 = price.join('')
                } else {
                  x.price17 = price[0]
                }
              }
            }
            // x.price16 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['Juni 2021'] && x['Juni 2021']) {
            let redemption = x['Juni 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Juni 2021'] = redemption
            const words = redemption.split(' ')
            x[41] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price18 = price.join('')
                } else {
                  x.price18 = price[0]
                }
              }
            }
            // x.price16 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          for (let i = 1; i <= 35; i++) {
            if (x[i] && x[i] !== '') {
              let redemption = x[i].replace(/\s/g, '')
              if (x.Pasien === '2020SMG247' && i === 29)
                console.log(redemption, 'words smg247')
              if (redemption.includes(',')) {
                const replaced = redemption.replaceAll(',', '')
                redemption = replaced
              }
              if (redemption.includes('.')) {
                const replaced = redemption.replaceAll('.', '')
                redemption = replaced
              }
              if (redemption.includes('(')) {
                const replaced = redemption.replaceAll('(', '')
                redemption = replaced
              }
              if (redemption.includes(')')) {
                const replaced = redemption.replaceAll(')', '')
                redemption = replaced
              }
              const words = redemption.split(' ')
              let redemptionDate = ''
              if (redemption.includes('/')) {
                redemptionDate = moment(words[0], 'DD/MM/YYYY').format(
                  'DD-MM-YYYY',
                )
                if (redemptionDate === 'Invalid date') {
                  redemptionDate = moment(words[0], 'M-DD-YY').format(
                    'DD-MM-YYYY',
                  )
                  if (x.Pasien === '2018BDG001') console.log(x['5'])
                }
              } else {
                redemptionDate = moment(words[0], 'DD-MM-YYYY').format(
                  'DD-MM-YYYY',
                )
                if (redemptionDate === 'Invalid date') {
                  redemptionDate = moment(words[0], 'DD-MMM-YY').format(
                    'DD-MM-YYYY',
                  )
                }
              }
              x[i] =
                words[0] &&
                words[0] !== '.' &&
                words[0] !== ' ' &&
                words[0] !== null
                  ? redemptionDate
                  : ''
              if (words[1]) {
                const price = words[1].match(/\d/g)
                if (price) {
                  if (price.length > 1) {
                    x[`price${i}`] = price.join('')
                  } else {
                    x[`price${i}`] = price[0]
                  }
                }
              }
            }
          }
          if (x.Pasien === '2020SMG246') console.log(x['17'], 'smg246')
          x['Tanggal Berhenti'] = x['Terminate (Month)']
          if (x['Tanggal Berhenti'] && x['Tanggal Berhenti'] !== 'null') {
            const terminatedDate = `01-${x['Tanggal Berhenti']}`
            x['Tanggal Berhenti'] = moment(terminatedDate, 'DD-MMM-YY').format(
              'YYYY-MM-DD',
            )
            if (x.Pasien === '2019MKS151') {
              console.log(x['Tanggal Berhenti'], 'MDN')
              console.log(terminatedDate, 'MDN Terminate')
            }
          }
          if (x.Penyebab === 'Lain-lain') {
            x.Penyebab = 'lain-lain'
          }
        })
        console.log(tableExcel, 'length')
      }
    },
    async bulk() {
      // eslint-disable-next-line
      const res = await bulkCreate()
      // console.log(res)
    },
    async cacheOrDatabase() {
      // let res = await getLatestPatientData(role)
      // res = res.filter((el) => el.code !== null)
      // console.log(res, '<<<< RESPONSE DATA')
      // if (this.$store.state.patientData.length > 0) {
      //   // console.log(res.length, 'res lengt')
      //   // console.log(this.$store.state.patientData.length, 'store lenght')
      //   if (res.length === this.$store.state.patientData.length) {
      //     console.log('cache')
      //     this.cityFilters = this.$store.state.cityFilters
      //     this.doctorFilters = this.$store.state.doctorFilters
      //     this.deathCauseFilters = this.$store.state.deathFilters
      //     this.pharmacyFilters = this.$store.state.pharmacyFilters
      //     this.items = this.$store.state.patientData
      //     this.filteredData = this.$store.state.patientData
      //     this.meanDoT = this.$store.state.meanDoT
      //     this.medianDoT = this.$store.state.medianDoT
      //     this.totalDoT = this.$store.state.totalDoT
      //     this.isLoading = false
      //   } else {
      this.getAllPatient()
      //     console.log('db2')
      //   }
      // } else {
      //   this.getAllPatient(role)
      //   console.log('db1')
      // }
    },
    async getAllPatient() {
      this.isLoading = true

      let res = await getLatestPatientData()
      const cityFilters = []
      const filtersComparison = []
      const doctorFilters = []
      const deathFilters = []
      const pharmacyFilters = []
      // let x1 = 0
      // let x2 = 0
      res = res.filter((el) => el.code !== null)
      this.isLoading = false
      for (const i in res) {
        let isApproved = false
        let user = res[i]
        // if (user.code === '2021TGR003') {
        //   console.log(user, 'ruky')
        //   console.log(user.program.programType)
        // }
        const duplicateTestLab = []
        const testLabs = []
        if (user.city) {
          const comparison = user.city.toUpperCase()
          if (!filtersComparison.includes(comparison)) {
            cityFilters.push(user.city)
            filtersComparison.push(comparison)
          }
        }
        if (user.testLabs && user.testLabs.length) {
          user.testLabs.forEach((el) => {
            const comparison = el?.testLabType?.name.toUpperCase()
            if (!duplicateTestLab.includes(comparison)) {
              testLabs.push(el?.testLabType?.name)
              duplicateTestLab.push(comparison)
            }
          })
          user.testLabs = testLabs
        }
        user = this.listRedemptionDates(user)
        user.mad = 0
        if (user.program) {
          if (user.program.programType) {
            user.programType = user.program.programType.name
          }
          user.isProgramNull = false
          if (user.program.price && user.program.drugsTakenDate) {
            const medicineCount = user.program.price.count
            const pillsTaken = await listAllTakenPills(
              user.id,
              user.program.drugsTakenDate,
            )
            // const enrollDate = user.program.drugsTakenDate
            // const today = new Date()
            // console.log(today, today)
            // console.log(typeof Date(enrollDate), Date(enrollDate))
            // const diff = moment(today).diff(enrollDate)
            // const seconds = diff / 1000
            // const minutes = seconds / 60
            // const hours = minutes / 60
            // const days = (hours / 24)
            // console.log(days, 'days')
            user.mad = (pillsTaken.pillsTaken / medicineCount) * 100
            user.prescription = medicineCount
            user.takenpills = pillsTaken.pillsTaken
          }
          if (user.program.doctor) {
            if (!doctorFilters.includes(user.program.doctor.fullname)) {
              doctorFilters.push(user.program.doctor.fullname)
            }
          }
          if (
            user.program.terminatedMessage &&
            user.program.terminatedMessage !== 'null'
          ) {
            if (!deathFilters.includes(user.program.terminatedMessage)) {
              deathFilters.push(user.program.terminatedMessage)
            }
          }
          if (user.program.pharmacy) {
            if (!pharmacyFilters.includes(user.program.pharmacy.name)) {
              pharmacyFilters.push(user.program.pharmacy.name)
            }
          }
          user.isTerminated = null
          user.prevProgram = null
          user.terminatedMessage = null
          if (!user.program.doctor) {
            user.program.doctor = { fullname: '-' }
            user.doctor = { fullname: '-' }
            user.doctorName = '-'
          } else {
            user.doctor = user.program.doctor
            user.doctorName = user.program.doctor.fullname
          }
          if (!user.program.checkPoint) {
            user.checkPoint = ''
          } else {
            user.checkPoint = user.program.checkPoint
          }
          if (!user.program.isApproved) {
            isApproved = false
          } else {
            isApproved = true
          }
          if (!user.program.pharmacy) {
            user.program.pharmacy = { name: '-' }
            user.pharmacy = { name: '-' }
            user.pharmacyName = ''
          } else {
            user.pharmacy = user.program.pharmacy
            user.pharmacyName = user.program.pharmacy.name
          }
          if (!user.program.prevProgram) {
            user.isPrevProgramNull = true
          } else {
            user.isPrevProgramNull = false
          }
          if (user.checkPoint === 6) {
            user.isCheckPointSix = true
          } else {
            user.isCheckPointSix = false
          }
          if (user.program.isTerminated)
            user.isTerminated = user.program.isTerminated
          if (user.program.terminatedMessage === 'null')
            user.program.terminatedMessage = '-'
          if (user.program.prevProgram)
            user.prevProgram = user.program.prevProgram
          if (user.program.terminatedMessage)
            user.terminatedMessage = user.program.terminatedMessage
          if (user.program.isTerminated) console.log(user.program.isTerminated)
        } else {
          user.isProgramNull = true
          isApproved = false
        }
        if (user.programs) {
          for (const i in user.programs) {
            user.programs[i].red = user.programs[i].enrollDate
              ? user.programs[i].enrollDate
              : user.programs[i].createdAt
          }
          const result = user.programs.reduce((unique, o) => {
            if (
              !unique.some(
                (obj) =>
                  moment(obj.red).format('YYYY/MM/DD') ===
                  moment(o.red).format('YYYY/MM/DD'),
              )
            ) {
              unique.push(o)
            }
            return unique
          }, [])
          // console.log(result)
          user.dot = result.length
          // this.totalDoT += user.dot
          // const mid = Math.ceil(filteredDot.length / 2)
          // const median = filteredDot.length % 2 === 0 ?
          // x1 = res[res.length / 2].dot
          // x2 = res[(res.length / 2) + 1].dot
          // this.meanDoT = this.totalDoT / res.length
          // this.medianDoT = (x1 + x2) / 2
          // this.$store.state.medianDoT = this.medianDoT
        } else {
          user.dot = 0
        }
        user.isApproved = isApproved
        this.filteredData = res
      }
      // const filteredDot = []
      // for (const i in res) {
      //   if (res[i].dot !== null) {
      //     filteredDot.push(res[i].dot)
      //   }
      // }
      // const filteredDotSort = filteredDot.sort()
      // const len = filteredDot.length
      // const sum = filteredDot.reduce((sum, val) => (sum += val))
      // const mid = Math.ceil(len / 2)
      // const median =
      //   len % 2 === 0
      //     ? (filteredDotSort[mid] + filteredDotSort[mid - 1]) / 2
      //     : filteredDotSort[mid - 1]
      // // console.log(median, 'median')
      // // console.log('average: ', sum / len)
      // // console.log(
      // //   // res.map((e) => e.years),
      // //   res,
      // //   '<<<<<',
      // // )
      // this.medianDoT = median
      // this.meanDoT = sum / len
      // this.$store.state.medianDoT = this.medianDoT
      // this.$store.state.meanDoT = this.meanDoT
      // this.$store.state.totalDoT = this.totalDoT
      // columns[0].children[0].filters = []
      // cityFilters.forEach(el => {
      //   columns[0].children[0].filters.push({
      //     text: el,
      //     value: el,
      //   })
      // })
      // columns[0].children[0].onFilter = (value, record) => {
      //   return record.city === value
      // }
      // columns[0].children[3].filters = []
      // // doctorFilters.forEach(el => {
      //   columns[0].children[3].filters.push({
      //     text: el,
      //     value: el,
      //   })
      // })
      // columns[0].children[4].filters = []
      // pharmacyFilters.forEach(el => {
      //   columns[0].children[4].filters.push({
      //     text: el,
      //     value: el,
      //   })
      // })
      // columns[0].children[6].filters = []
      // deathFilters.forEach(el => {
      //   columns[0].children[6].filters.push({
      //     text: el,
      //     value: el,
      //   })
      // })
      // res = res.filter(el => el.isApproved === true)
      this.cityFilters = cityFilters
      this.doctorFilters = doctorFilters
      this.deathCauseFilters = deathFilters
      this.pharmacyFilters = pharmacyFilters
      this.$store.state.cityFilters = cityFilters
      this.$store.state.doctorFilters = doctorFilters
      this.$store.state.deathCauseFilters = deathFilters
      this.$store.state.pharmacyFilters = pharmacyFilters
      // this.columns = columns
      this.isLoading = false
      this.$store.state.patientData = res
      this.items = res
      this.filteredData = res
      // console.log(this.items)
    },
    async listPillsTaken(user) {
      const enrollDate = user.program.drugsTakenDate
      const today = new Date()
      console.log(today, today)
      console.log(typeof Date(enrollDate), Date(enrollDate))
      const diff = moment(today).diff(enrollDate)
      const seconds = diff / 1000
      const minutes = seconds / 60
      const hours = minutes / 60
      const days = hours / 24
      const pills = await listAllPillsStatus(
        user.id,
        parseInt(days),
        enrollDate,
        user.program.price.count,
      )
      this.pills = pills
      console.log(pills, 'days')
    },
    onFilter(items) {
      //     selectedDoctorFilter: '',
      // selectedCityFilter: '',
      // selectedPharmacyFilters: '',
      // selectedStatusFilters: '',
      // selectedDeathCauseFilters: '',
      const filters = {
        // city: this.selectedCityFilter,
        // terminatedMessage: this.selectedDeathCauseFilters,
        // pharmacy: this.selectedPharmacyFilters,
        // record.program && record.checkPoint !== 6 && record.prevProgram === null && record.isTerminated === null)
      }
      if (this.selectedCityFilter.length > 0) {
        filters.city = this.selectedCityFilter
      }
      if (this.selectedDeathCauseFilters.length > 0) {
        filters.terminatedMessage = this.selectedDeathCauseFilters
      }
      if (this.selectedPharmacyFilters.length > 0) {
        filters.pharmacyName = this.selectedPharmacyFilters
      }
      if (this.selectedDoctorFilter.length > 0) {
        filters.doctorName = this.selectedDoctorFilter
      }
      // console.log(items,'<<<ITEMS')
      // console.log(this.filteredData,'<<<FILTERED ITEM BBEFORE')
      this.filteredData = items.filter((item) => {
        for (var key in filters) {
          if (!filters[key].includes(item[key])) {
            return false
          }
        }
        return true
      })
      // console.log(this.filteredData,'<<<FILTERED ITEM AFTER')
      if (this.selectedStatusFilters) {
        this.statusFilter(this.filteredData)
      }
    },
    statusFilter(items) {
      if (this.selectedStatusFilters) {
        const value = this.selectedStatusFilters
        // if (this.selectedStatusFilters === 'Pasien Baru') {
        //   filters.isProgramNull = false
        //   filters.isCheckPointSix = false
        //   filters.prevProgram = null
        //   filters.isTerminated = null
        // } else if (this.selectedStatusFilters === 'Belum Terdaftar') {
        //   filters.program = null
        // } else if (this.selectedStatusFilters === 'Perpanjang') {
        //   filters.isPrevProgramNull = false
        //   filters.isTerminated = null
        // } else if (this.selectedStatusFilters === 'Berhenti') {
        //   filters.isTerminated = true
        // }
        // console.log(filters, 'filters')
        // this.filteredData = items.filter((item) => {
        //   for (var key in filters) {
        //     if (item[key] === undefined || item[key] !== filters[key]) {
        //       return false
        //     }
        //     return true
        //   }
        // })
        if (value === 'Belum Terdaftar')
          this.filteredData = items.filter((record) => record.program === null)
        else if (value === 'Belum Scan QR')
          this.filteredData = items.filter(
            (record) =>
              record.program &&
              record.isApproved &&
              record.isTerminated !== true &&
              record.checkPoint !== 6 &&
              record.program.isDrugsTaken !== true,
          )
        else if (value === 'Tidak Aktif')
          this.filteredData = items.filter(
            (record) =>
              record.program &&
              record.isApproved &&
              record.isTerminated !== true &&
              record.checkPoint !== 6 &&
              record.program.reminderDate &&
              moment(record.program.reminderDate).isBefore(
                moment().subtract(2, 'months'),
              ),
          )
        else if (value === 'Pasien Baru')
          this.filteredData = items.filter(
            (record) =>
              record.program &&
              record.checkPoint !== 6 &&
              record.prevProgram === null &&
              record.isTerminated === null &&
              record.program.isDrugsTaken === true,
          )
        else if (value === 'Perpanjang')
          this.filteredData = items.filter(
            (record) =>
              record.prevProgram &&
              record.isTerminated !== true &&
              record.program.isDrugsTaken === true,
          )
        else if (value === 'Berhenti')
          this.filteredData = items.filter((record) => record.isTerminated)
      }
    },
    getProgramtype(id) {
      switch (id) {
        case '3a1845a1-28df-403d-a40d-e8173f511fc9':
          return 'TAGRISSO'
        case 'f20ef325-c767-444c-927d-71d4c3600f67':
          return 'FASLODEX'
        case '579d64ca-8ba8-458b-9534-47207e86a6a6':
          return 'LYNPARZA'
        default:
          return '-'
      }
    },
    // onStatusFilters (value) {
    //   if (value) {
    //     if (value === 'Belum Terdaftar') this.filteredData = this.items.filter(record => record.program === null)
    //     else if (value === 'Pasien Baru') this.filteredData = this.items.filter(record => record.program && record.checkPoint !== 6 && record.prevProgram === null && record.isTerminated === null)
    //     else if (value === 'Perpanjang') this.filteredData = this.items.filter(record => record.prevProgram && record.isTerminated !== true)
    //     else if (value === 'Berhenti') this.filteredData = this.items.filter(record => record.isTerminated)
    //   } else {
    //     this.filteredData = this.items
    //   }
    // },
    // onDoctorFilters (value) {
    //   if (value) {
    //     this.filteredData = this.items.filter(record => record.doctorName === value)
    //   } else {
    //     this.filteredData = this.items
    //   }
    // },
    // onPharmacyFilters (value) {
    //   if (value) {
    //     this.filteredData = this.items.filter(record => record.pharmacyName === value)
    //   } else {
    //     this.filteredData = this.items
    //   }
    // },
    // onDeathCauseFilters (value) {
    //   if (value) {
    //     this.filteredData = this.items.filter(record => record.terminatedMessage && record.terminatedMessage === value)
    //   } else {
    //     this.filteredData = this.items
    //   }
    // },
    viewDetails(id) {
      router.push('/pasien/details/' + id)
    },
    listRedemptionDates(user) {
      user.januari = '-'
      user.februari = '-'
      user.maret = '-'
      user.april = '-'
      user.mei = '-'
      user.juni = '-'
      user.juli = '-'
      user.agustus = '-'
      user.september = '-'
      user.oktober = '-'
      user.november = '-'
      user.desember = '-'
      user.years = []
      const yearDuplicate = []
      if (user.code === '2021JAM003') {
        console.log(this.year, 'this year')
        console.log(user.programs, 'programs')
      }
      for (const j in user.programs) {
        // const redemption = user.programs[j].enrollDate ? user.programs[j].enrollDate : user.programs[j].createdAt
        const redemption = user.programs[j].createdAt
        const program = user.programs[j]
        const comparison = moment(redemption).year()
        if (!yearDuplicate.includes(comparison)) {
          user.years.push(comparison)
          yearDuplicate.push(comparison)
        }

        if (
          moment(redemption).isBefore(`${this.year}-01-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-01-01`, 'day')
        ) {
          user.januariPriceName = program.price ? program.price.name : '-'
          user.januari = redemption
            ? moment(redemption).format('DD-MM-YYYY')
            : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-02-28`, 'day') &&
          moment(redemption).isAfter(`${this.year}-02-01`, 'day')
        ) {
          user.februari =
            redemption !== null ? moment(redemption).format('DD-MM-YYYY') : '-'
          user.februariPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-03-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-03-01`, 'day')
        ) {
          user.maret = moment(redemption).format('DD-MM-YYYY')
          user.maretPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-04-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-04-01`, 'day')
        ) {
          user.april = moment(redemption).format('DD-MM-YYYY')
          user.aprilPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-05-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-05-01`, 'day')
        ) {
          user.mei = moment(redemption).format('DD-MM-YYYY')
          user.meiPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-06-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-06-01`, 'day')
        ) {
          user.juni = moment(redemption).format('DD-MM-YYYY')
          user.juniPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-07-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-07-01`, 'day')
        ) {
          user.juli = moment(redemption).format('DD-MM-YYYY')
          user.juliPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-08-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-08-01`, 'day')
        ) {
          user.agustus = moment(redemption).format('DD-MM-YYYY')
          if (user.code === '2021JAM003') {
            console.log('masuk agustus')
            console.log(user.agustus)
          }
          user.agustusPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-09-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-09-01`, 'day')
        ) {
          user.september = moment(redemption).format('DD-MM-YYYY')
          user.septemberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-10-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-10-01`, 'day')
        ) {
          user.oktober = moment(redemption).format('DD-MM-YYYY')
          user.oktoberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-11-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-11-01`, 'day')
        ) {
          user.november = moment(redemption).format('DD-MM-YYYY')
          user.novemberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-12-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-12-01`, 'day')
        ) {
          user.desember = moment(redemption).format('DD-MM-YYYY')
          user.desemberPriceName = program.price ? program.price.name : '-'
        }
      }
      return user
    },
  },
}
</script>

<style lang="scss" module>
@import '../../../components/tables/pasien/style.module.scss';
</style>
